import DatiCliente from "./DatiCliente";
export default DatiCliente;
